<template>
  <div id="vue-bubble-menu" class="b-menu">
    <keep-alive>

      <router-view name="bMenuRouterView"></router-view>

      <b-menu-view :initial-children="initialChildren">
        <template v-slot:mainBubbleContent>
          <slot name="mainBubbleContent"
                :parent="initialParent"
                :activeChild="StoreHelper.getActiveChild()"
                :hover="StoreHelper.isHoverInProgress()"
                :edit="StoreHelper.isEditInProgress()">
          </slot>
        </template>

        <template v-if="$scopedSlots.paginationActions" v-slot:paginationActions="props">
          <slot name="paginationActions" v-bind="props"></slot>
        </template>

      </b-menu-view>

    </keep-alive>
  </div>
</template>

<script>
import BMenuView from '../views/b-menu-view'

import EventBus, { Events } from '../event-bus'

import StoreHelper from '../store/helper'
import OrderManager from '../util/OrderManager'
import ViewManager from '../util/ViewManager'

export default {
  name: 'b-menu',
  components: {
    'b-menu-view': { extends: BMenuView }
  },
  props: {
    initialParent: {
      type: Object
    },
    initialChildren: {
      type: Array,
      default: () => []
    },
    showActions: {
      type: Boolean,
      default: false
    },
    draggableBubbles: {
      type: Boolean,
      default: false
    },
    pagination: {
      type: Boolean,
      default: false
    },
    activeItem: {
      type: Object
    }
  },
  data () {
    return { StoreHelper }
  },
  created () {
    EventBus.$on(Events.B_MENU_ITEM_CLICKED, (item) => {
      this.$emit('click:menu-item', item)
    })

    EventBus.$on(Events.B_MENU_BACK_CLICKED, (parent) => {
      this.$emit('click:menu-back', parent)
    })

    EventBus.$on(Events.B_MENU_BREADCRUMB_ITEM_CLICKED, (item) => {
      this.$emit('click:breadcrumb-item', item)
    })

    EventBus.$on(Events.B_MENU_ITEM_DELETE, (item) => {
      this.$emit('click:item-delete', item)
    })

    EventBus.$on(Events.B_MENU_ACTIVE_VIEW_CHANGED, () => {
      this.$emit('update:active-item', StoreHelper.getActiveViewData().parent)
    })

    // EventBus.$on(Events.B_MENU_ITEM_EDIT, (item) => {
    //   this.$emit('click:item-edit', item)
    // })

    EventBus.$on(Events.B_MENU_ITEM_SAVE, (item) => {
      this.$emit('update', item)
    })

    EventBus.$on(Events.B_MENU_ITEM_DRAG_START, (item) => {
      this.$emit('drag:start', item)
    })

    EventBus.$on(Events.B_MENU_ITEM_DRAG_END, (item) => {
      this.$emit('drag:end', item)
    })

    EventBus.$on(Events.B_MENU_ITEM_ORDER_CHANGED, (item, dropPosition) => {
      const reorderedItem = OrderManager.reorderItem(StoreHelper.getActiveViewItems(), item, dropPosition)

      ViewManager.replaceOrAddItemInView(StoreHelper.getActiveViewPath(), reorderedItem)
      this.$emit('update:order', reorderedItem)
    })

    EventBus.$on(Events.B_MENU_ITEM_PARENT_CHANGED, (item, target) => {
      this.$emit('change:item-parent', item, target)
    })

    StoreHelper.setShowActions(this.showActions)
    StoreHelper.setDraggableBubblesEnabled(this.draggableBubbles)
    StoreHelper.setPaginationEnabled(this.pagination)
  }
}
</script>

<style lang="scss" scoped>
#vue-bubble-menu.b-menu {
  position: relative;
  height: 100%;
  width: 100%;
}
</style>

<style lang="scss">
@import "../assets/style/keyframes/pulse-scale";
</style>
